import { render, staticRenderFns } from "./LmNoDataIcon.vue?vue&type=template&id=9ecf2130"
import script from "./LmNoDataIcon.vue?vue&type=script&lang=js"
export * from "./LmNoDataIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports